

import './App.css';

import React,  {useEffect, useState} from "react";
import { BrowserRouter ,  Switch, Route } from "react-router-dom";
import {  useDispatch } from "react-redux";

import { initUser} from "./store/actions/initialization";

import { useSelector } from "react-redux";
import NoMatch from "./components/NoMatch/NoMatch";
import ProtectedRoute from "./ProtectedRoute";
import Loading from "./components/Loading/Loading";
import loadable from '@loadable/component';
import MenuBar from "./MenuBar";
import "./styleAll.css";
import ResetPassword from "./components/ResetPassword";
import ResetPassOTP from "./components/ResetPassOTP";
import AddNewPassWord from "./components/AddNewPassword";
import HomeCreateCourse from "./HomeCreateCourse";
import LoginWithOTP from "./components/LoginWithOTP";
import ValidateOTP from "./components/ValidateOTP";
import Dashboard from "./components/Dashboard";
import LiveClass from "./components/LiveClass/LiveClass";
import ClassUI from "./components/LiveClass/Components/ClassUI";
import MyApps from "./components/MyApps";
import CustomCursor from "./components/CustomCursor";
import MyHomePage from "./components/MyHomePage";
import PreviewCoursePopup from "./components/Create/CreateCourse/PreviewCourse/PreviewCoursePopup";
import CRM from "./components/CRM/CRM";
import AppSettings from "./components/Create/CreateApp";
import CreateContent from "./components/Create/CreateContent";
import HomeCreateContent from "./HomeCreateContent";
import Templates from "./components/Create/CreateWebsite/Templates";
import { HeroCard10, HeroCard2 } from './components/Create/CreateWebsite/Cards/HeroCard';
import FunnelCanvas from './components/Create/Funnels/ClickFunnels/FunnelCanvas';
import EmailWalletPage from './components/Create/RazorpayAccount/EmailWalletPage/EmailWalletPage';
import CreditRechargePanel from './components/credits/CreditRechargePanel';
import AdminCreditPacks from './components/SuperAdmin/AdminCreditPacks';
import SuperAdminDashboard from './components/SuperAdmin/SuperAdminDashboard';
import TenantCreditDashboard from './components/credits/TenantCreditDashboard';
import StudentListDashboard from './components/User/lists/ListDashboard';
import StudentListDetails from './components/User/lists/ListDetails';
import AccessControlPage from './components/AccessControl/pages/AccessControlPage';
let lazyLoad =   <Loading/>;
  ;

  const Login = loadable(() => import("./components/Login"), {
    fallback: lazyLoad  });
    const SignUp = loadable(() => import("./components/SignUp"), {
      fallback: lazyLoad  });

function App() {
  
 const dispatch = useDispatch();
 
  
   const localToken= localStorage.getItem("profile");
   const token = useSelector((state)=>state?.user?.user?.token);
  
// getting data from store.
const data = useSelector((state)=>state?.user?.user);
const liveClassdata = useSelector((state)=>state?.user?.liveClass);
//const user_id = useSelector((state)=>state?.user?.user);

   const pathname = window.location.pathname;
 const routerLocation = useSelector((state)=>state?.app?.routerLocation);
 const AppToken = useSelector((state)=>state?.app?.app?.AppToken);

const [loadNavbar ,setLoadNavbar] =useState(true);

//console.log(data)


useEffect(()=>{
  // alert(routerLocation)
  setLoadNavbar(false);
  setTimeout(()=>{
    setLoadNavbar(true);
  },0)
},[routerLocation])
useEffect(()=>{
    
  dispatch(initUser(data))

  /* dont put data as dependency as it will produce error with redux-persist.
  user will be initiated again and again and token may change infinitely,
  which will affect login & protect-route mechanism.
  */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[dispatch])     
   return (<div  className="" >
    <CustomCursor  />
    <BrowserRouter>
    <MenuBar/>
         {/* {loadNavbar?pathname!==`/apps/${AppToken}/settings`&&pathname!==`/apps/${AppToken}/website`? <MenuBar/>:"":""}   */}
         <Switch>
        
        
        
        
        <Route path="/signup" component={SignUp}/>
                 {/* <Route  path="/signup"> <SignUp/> </Route> */}
                 <Route  path="/login" component={Login}/>
                 <Route  path="/resetPassword" component={ResetPassword}/>
                 <Route  path={`/resetPassOTP`}>
<ResetPassOTP/>
      </Route>
      <Route  path="/addNewPassWord" component={AddNewPassWord}/>
      <Route  path="/loginWithOTP" component={LoginWithOTP}/>
      <Route  path="/validateOTP" component={ValidateOTP}/>
     
      <Route  path="/funnel/canvas" component={FunnelCanvas}/>
      <Route  path="/emailWallet" component={EmailWalletPage}/>
      <Route  path="/credits" >
      <TenantCreditDashboard  />
      </Route>
       <Route  path="/AccessControl" >
      <AccessControlPage />
      </Route>
      <Route  path="/super-admin" >
      <SuperAdminDashboard />
      </Route>
         <Route exact user={{}}  path="/apps/dashboard"><StudentListDashboard/></Route>
    <Route exact user={{}}  path="/apps/dashboard/lists/:listId?"><StudentListDetails/></Route>
   

       
      <ProtectedRoute user={{}}  path="/live"><LiveClass/></ProtectedRoute>
      <ProtectedRoute user={{}}  path="/class"><ClassUI/></ProtectedRoute>
               

      <ProtectedRoute user={{}}  path="/dashboard"><Dashboard/></ProtectedRoute>
      <ProtectedRoute user={{}}  path="/crm"><CRM/></ProtectedRoute>
     <Route user={{}}  path="/apps"><MyApps/></Route>
     {(token===localToken&&token&&localToken)? <Route user={{}}  path="/"><MyApps/></Route>:<Route exact path="/"  component={HeroCard2}/>}
     
                 <ProtectedRoute user={{}}  path="/messenger"> </ProtectedRoute>
                 <ProtectedRoute user={{}}  path="/checkout"> </ProtectedRoute>
                
   
                 <Route  path="/templates" component={Templates}/>
                 <Route  path="/create-course" component={HomeCreateCourse}/>
                 <Route  path="/create-content" component={HomeCreateContent}/>
  
                 <Route  path="/preview-course" component={PreviewCoursePopup} />

<Route  path="*"> <NoMatch/>  </Route>    
          </Switch>
    </BrowserRouter>
    </div>
  );
};
export default App;






